<template>
    <div class="app">
        <vue-toastr ref="toastr" />
        <AppHeader/>
        <div class="app-body">
            <AppSidebar/>
            <router-view class="main"></router-view>
            <!--<AppAside/>-->
        </div>
        <AppFooter/>
    </div>
</template>

<script>
    import {
        Header as AppHeader,
        Sidebar as AppSidebar,
        Aside as AppAside,
        Footer as AppFooter
    } from '../components/'
    import Toastr from 'vue-toastr'

    export default {
        name: 'full',
        components: {
            AppHeader,
            AppSidebar,
            AppAside,
            AppFooter,

            'vue-toastr': Toastr
        },
        data () {
            return {}
        },
        computed: {
            name () {
                return this.$route.name
            }
        },
        created () {
            this.$on('alert-info', (message) => {
                this.$refs['toastr'].i(message)
            })
        }
    }
</script>

<style>
    .main {
        padding-top: 1rem;
        position: relative;
    }
    .blur {
        filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius='3');
        -webkit-filter: blur(3px);
        filter: blur(3px);


    }
    .loading-container {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        padding-top: 120px;
        z-index: 10000;
    }
</style>


// WEBPACK FOOTER //
// Full.vue?3a5d1533